import { useAtomValue } from 'jotai';

import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { FUEL_TYPES } from '@core/Utils/VehicleMappedMessages/FuelTypeMappings.constants';
import { MultiSelect } from '@plp/Components/MultiSelect/MultiSelect';
import { getOptionsWithAggs } from '@plp/Utils/Filters/GetOptionsWithAggs';
import { useMultiSelectFilters } from '@search-filters/Hooks/UseMultiSelectFilters';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';
import ApplyButton from '../ApplyButton/ApplyButton';

import styles from './FuelFilter.module.css';

type FuelFilterProps = FilterControlBaseProps;

export const FuelFilter = ({
  strings,
  isPlpFiltersSeoEnabled,
  tenant,
  applyButton,
}: FuelFilterProps) => {
  const aggs = useAtomValue(aggregationsAtom);

  const { handleSelect, handleApply, listWithSelected } = useMultiSelectFilters(
    'fuel-type',
    getOptionsWithAggs(FUEL_TYPES, aggs['fuel-type']),
    strings,
    isPlpFiltersSeoEnabled,
    tenant,
    undefined,
    applyButton,
  );

  return (
    <section className={styles.fuelFilter}>
      <MultiSelect
        groupName="fuel-type"
        classes={{ label: styles.listItem }}
        items={listWithSelected}
        onSelect={(id, checked) => {
          handleSelect(id, checked);
        }}
        dataTestId="fuel-filter-list"
        applyButton={applyButton}
      />
      {applyButton && <ApplyButton handleApply={handleApply} ctaText={strings.apply} />}
    </section>
  );
};
